export default __webpack_public_path__ + "static/media/profile-owner.f93aa193.svg";